module.exports = __webpack_public_path__ + "static/media/lc.ee66a25b.svg";